import type { LottiePlayer } from 'lottie-web/build/player/lottie_light';

// This controller is used to asyc load lottie-web library
class LottieController {
  public lottie: LottiePlayer | null = null;

  private listeners = new Map<string, (lottie: LottiePlayer) => void>();

  // add listener callback to listeners Map
  public addListener(name: string, listener: (lottie: LottiePlayer) => void): void {
    this.listeners.set(name, listener);
  }

  // load lottie-web library, write it to lottie property
  init(): void {
    if (this.lottie) {
      return;
    }
    import(/* webpackChunkName: "lottie"*/ 'lottie-web/build/player/lottie_light')
      .then((lottie) => {
        this.lottie = lottie.default;
        for (const callback of this.listeners.values()) {
          callback(lottie.default);
        }
      })
      .catch(() => {
        // Add error handling if needed
      });
  }
}

// export initialized lottie controller instance
export default new LottieController();
